import React from 'react';

interface RemarksSectionProps {
  remarks: string;
  onRemarksChange: (value: string) => void;
  disabled?: boolean;
}

export const RemarksSection: React.FC<RemarksSectionProps> = ({
  remarks,
  onRemarksChange,
  disabled = false
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3.5">
      <div className="flex items-center gap-1.5 mb-2.5">
        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
        <span className="text-sm font-semibold text-gray-900 dark:text-gray-100">Remarks</span>
      </div>
      <textarea
        value={remarks}
        onChange={(e) => onRemarksChange(e.target.value)}
        disabled={disabled}
        placeholder="Enter any remarks or notes..."
        rows={3}
        className="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white disabled:bg-gray-100 dark:disabled:bg-gray-800 resize-y"
      />
    </div>
  );
};

